import { API_BASE_URL } from "./config";

export const DEMO_MODE_KEY = "timetab_demo_mode";
export const DEMO_ORIGINAL_TOKEN_KEY = "timetab_demo_original_session_token";

const DEMO_ALLOWED_ROUTES = new Set([
  "/welcome",
  "/admin/dashboard",
  "/punch_clock",
  "/availability",
  "/team",
  "/approval/flow",
  "/demand",
  "/shiftplan",
  "/report",
  "/report/shiftplan",
  "/FAQ",
]);

export function isDemoMode() {
  return localStorage.getItem(DEMO_MODE_KEY) === "true";
}

export async function startDemoMode() {
  const currentToken = localStorage.getItem("session_token");
  if (!currentToken) {
    throw new Error("A valid session is required to start demo mode.");
  }

  const response = await fetch(`${API_BASE_URL}/api/web/demo/session`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${currentToken}`,
      "Content-Type": "application/json",
    },
    body: "{}",
  });

  if (!response.ok) {
    throw new Error("Demo mode could not be started.");
  }

  const data = await response.json();
  if (!data.session_token) {
    throw new Error("Demo session token was not returned.");
  }

  localStorage.setItem(DEMO_ORIGINAL_TOKEN_KEY, currentToken);
  localStorage.setItem("session_token", data.session_token);
  localStorage.setItem(DEMO_MODE_KEY, "true");
  window.dispatchEvent(new Event("timetab:demo-mode-changed"));
}

export function stopDemoMode() {
  const originalToken = localStorage.getItem(DEMO_ORIGINAL_TOKEN_KEY);
  if (originalToken) {
    localStorage.setItem("session_token", originalToken);
  }
  localStorage.removeItem(DEMO_ORIGINAL_TOKEN_KEY);
  localStorage.removeItem(DEMO_MODE_KEY);
  window.dispatchEvent(new Event("timetab:demo-mode-changed"));
}

export function getDemoRouteDestination(pathname) {
  if (!isDemoMode()) return null;
  return DEMO_ALLOWED_ROUTES.has(pathname) ? null : "/admin/dashboard";
}
